import { render, staticRenderFns } from "./ConfirmRecreationPage.vue?vue&type=template&id=ddca51c4"
import script from "./ConfirmRecreationPage.vue?vue&type=script&lang=js"
export * from "./ConfirmRecreationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports